import React,{ useState, useEffect} from 'react';
import ScrollToTopBtn from './components/Button/ScrollToTopBtn.js';
import styled from 'styled-components';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import UncontrolledExample from './components/Carousel/carousel.js'; 
import ProjectSideSection from './components/ProjectSideSection/ProjectSideSection.js';


const OutcomeOverview = styled.div`
	width: 100%;
	height: auto;
	min-height: 100vh;
	background-color: #000;
	color: var(--color-white);
	// padding: 0 5rem;
	:nth-child(2n+1) {
		background-color: #111;
	}
	:nth-child(2n+1) h3,
	:nth-child(2n+1) .description h1,
	:nth-child(2n+1) .description p {
		color: #fff;
	}
	:nth-child(2n+1) .description .tag {
		background-color: #fff;
		color: var(--color-text);
    }
    .description {
    	display: flex;
    	flex-direction: column;
    	justify-content: center;
    	padding: 2rem;
    }
    .description.onleft {
    	padding-right: 2rem;
    	padding-left: 0;
    }
    .description h1 {
    	font-size: 24px;
    	font-weight: 300;
    	color: var(--color-text);
    }
    .description p .emoji {
    	font-size: 160%;
    	vertical-align:middle;
    }
    .description p {
    	margin-top: 0;
    	font-size: 110%;
		color: #eee;
    }
	.portfolio-content .section-box p a {
		color: #2B90FF;
		text-decoration: underline;
    }
    .description strong {
    	color: #2B90FF;
    	font-weight: bold;
    }
    .description .tag {
    	font-size: 14px;
	    letter-spacing: .5px;
	    margin: 10px 0;
    }
    .image {

		display: flex;
	    align-items: center;
	    justify-content: center;
	    position: relative;
	    box-sizing: border-box;
	}
	.image::before {
	    content: '';
	    display: block;
	    padding-top: 60%;
	}
	.image img {
    	position: absolute;
		height: 100%;
	}
	.image video {
    	position: absolute;
		height: 100%;
	}
	.image img.widthfixed {
		width: 100%;
		height: auto;
		border: 8px solid #111;
		border-radius: 4px;
	}
	.image video.widthfixed {
		width: 100%;
		height: auto;
		border: 8px solid #111;
		border-radius: 4px;
	}
	h4 {
		margin: 0;
	}
`;
const DesignGoal = styled.div`
	<!-- display: flex; -->
	flex-direction: column;
	align-items: start;
	padding: 0 10px 0 0;
	height: 100%;
	>* {
		margin: 0 auto;
	}
	>img {
		display: inline-block;
		position: relative;
		width: 100%;
		height: auto;
	}
	>img:before {
		position: absolute:
		display: block;
		width: 20px;
		height: 20px;
		border-radius: 30px;
		
	}
	>div:last-child {
    padding-right: 0;
    margin-right: 0;
    background-color: red;
  }
	>h1 {
		width: 100%;
		margin: 0;
		color: #0079FF;
		font-size: 4.5em;
		margin-bottom: 10px;
		<!-- text-align: center; -->
	}
	>h3 {
		margin: 20px 0;
		font-weight: 600;
	}
	>p {
		padding-right: 10px;
		margin-bottom: 40px;
	}
`
function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { return images[item.replace('./', '')] = r(item); });
  return images;
}

const images = importAll(require.context('./assets/img/fanduel3/', false, /\.(png|jpe?g|svg|gif)$/));

const controls = [
		{ 
	    	src: images['token-1.png'],
	    	class: ''
		},
		{ 
	    	src: images['token-2.png'],
	    	class: ''
		}
];
const control2 = [
		{ 
			title: '',
			category: '',
			description: '',
			images: [images['visualspecdoc.png'],images['popoverautolayout.gif'],images['designtesting.gif']],
		}
]
const popoverControls = [
	{ 
    	src: images['popoverautolayout.gif'],
    	class: 'widthfixed'
	},
	{ 
    	src: images['designtesting.gif'],
    	class: 'widthfixed'
	}
];
const trainingControls = [
	{ 
    	src: images['workshop.png'],
    	class: ''
	},
	{ 
    	src: images['training.png'],
    	class: ''
	}
];
const Wyndham = (props) => {
	useEffect(()=>{
		const faders = document.querySelectorAll(".section-box");

		const appearOptions = {
			threshold: 0,
			rootMargin: "0px 0px -150px 0px"
		};

		const appearOnScroll = new IntersectionObserver(function(
			entries,
			appearOnScroll
		) {
			entries.forEach(entry => {

				if (!entry.isIntersecting) {
					return;
				} else {
					entry.target.classList.add("appear");
					entry.target.classList.add("animate__animated");
					entry.target.classList.add("animate__fadeInUp");
					appearOnScroll.unobserve(entry.target);
				}
			});
		},
		appearOptions);

		faders.forEach(fader => {
			appearOnScroll.observe(fader);
		});



	},[])
	

		return (
		<div className="flex fanduel" style={{position: "relative", top: "80px"}}>
			<portfolio-intro className="flex">
				
				<div className="hero-img-box">
					<img src={images['cover0.png']} style={{backgroundColor: '#222', height:"auto", width:"100%"}} alt="" />
				</div>
				
			</portfolio-intro>

			<div className="portfolio-content flex-width-70">
				<h1>Formation Design System</h1>
				<div className="section-box brief">
					<div className="grid grid-gap-xs">
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>My Role</h4>
							<ul>
								<li>Product Designer</li>
							</ul>
						</div>
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>Duration</h4>
							<ul>
								<li>2023 - 2025</li>
							</ul>
							
						</div>
						
						
						<div className="col-xl-4 col-md-4 col-xs-6 col-6">
							<h4>Tools</h4>
							<ul>
								<li>Figma, Confluence, Jira, Storybook</li>
							</ul>
							
						</div>
					</div>	
				</div>
				
				<div className="section-box">
					<h3 className="section-title">My Impact</h3>

					<p>I played a key role in evolving its <strong>scalability</strong>, <strong>usability</strong>, and <strong>adoption</strong> across multiple product teams. I streamlined component workflows, established robust documentation, and built custom Figma plugins to automate repetitive tasks like token spec generation and component upgrades. Through close collaboration with cross-functional teams, I increased design system adoption by 170%, improved quality and coverage scores from 31 to 85, and significantly accelerated the design-to-development process across platforms.</p>
				</div>
				<div className="section-box">
					<h3>The Challenge</h3>
					<p>When I joined, the design system team was still in its early stages and lacked clear ownership and maintenance of core component libraries. Multiple product teams had created and managed their own product-specific components, leading to fragmented libraries and duplicated efforts. As a result, there were widespread inconsistencies in UI patterns, behaviors, and visual styles across the organization, making it difficult to maintain a cohesive user experience and slowing down both design and development workflows.</p>
				</div>
				<div className="section-box">
					<h3>The Solution</h3>
					<p>We approached the Design System as a <strong>product</strong> in itself. Focused on <strong>efficiency</strong>, <strong>consistency</strong>, and real <strong>impact</strong>. Every aspect of creating, maintaining, and evolving the system followed a full end-to-end design process: from research and auditing current design, to iterating on solutions, defining specs and behaviors, conducting technical reviews, and supporting handoffs and releases. By collaborating closely with product teams and being intentional at every step, we ensured the system addressed real pain points, improved consistency, and drove efficiency across the entire products ecosystem.</p>
					<br />
					<img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['designprocess1.png']} alt="" />
					<br />
					{/* <p>Here's an example of a technical review I conducted for a new component.</p>
		
					<img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['techreview.png']} alt="" /> */}
					
    			
				</div>

			</div>


		

			<div className="portfolio-content flex-width-70" style={{"padding-top": "0"}}>
				<div className="section-box">
					<h3 className="section-title">System Thinking & Architecture</h3>
					<p> I defined and standardized a clear library structure to support scalable, intuitive navigation, using a <strong>File &gt; Page &gt; Frame &gt; Component</strong> model. 
						For complex components, I added an in-page structure: <strong>Main Components &gt; Nested Components &gt; Hidden Subcomponents</strong> (not published) to support modular design without cluttering the library. 
					</p>
					<p>I created in-Figma documentation for a product team by defining in-page sections to show light/dark mode visuals, component variations, patterns, examples, and templates. This helped designers quickly understand usage, maintain consistency, and improved discoverability. It also reduced duplication and made onboarding easier across teams.</p>
					<br />
					
					{/* <img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['complexstructure.png']} alt="" /> */}
					{/* <ProjectSideSection 
						key = {"architecture"}
						title={"Design System Architecture"}
						category={"System Design|Library Structure|Documentation"}
						description={"Clear library structure with File > Page > Frame > Component model, supporting scalable navigation and modular design with in-page documentation for light/dark modes, variations, patterns, and templates."}
						images = {[images['complexstructure.png']]}
					/>
					<ProjectSideSection 
						key = {control2[0].title} 
						title={control2[0].title} 
						category={control2[0].category} 
						description={control2[0].description}
						images = {control2[0].images}
					/> */}
					
				</div>
			</div>
			{/* <div className="section-box fullscreen-container flex flex-center"> */}
				<OutcomeOverview style={{backgroundColor: "#27272B", minHeight: "0"}} className="text-center">
					<img style={{width: "100%"}} src={images['complexstructure.png']} alt="documentation" />
				</OutcomeOverview>
			{/* </div> */}
			
			{/* <div className="section-box fullscreen-container flex flex-center">
				<OutcomeOverview style={{backgroundColor: "#27272B", minHeight: "0"}} className="text-center">
					<img style={{width: "100%"}} src={images['complexstructure.png']} alt="complexstructure" />
				</OutcomeOverview>
			</div> */}

			<div className="portfolio-content flex-width-70" style={{"padding-top": "0"}}>
				<div className="section-box">
					<h3 className="section-title">Component Design with Scale</h3>
					<p>I defined standards for component creation with a focus on consistency, flexibility, scalability, and maintainability. To support this, I introduced a component checklist and regularly reviewed builds to ensure alignment with system guidelines and long-term usability.</p>
					<br />
					<img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['component.png']} alt="" />
					<img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['componentesign.png']} alt="" />
					<br />
					{/* <div style={{height: "80vh", width: "100%", marginTop: ""}}> */}
						<UncontrolledExample controls={popoverControls} carouselId="popover-carousel" />
					{/* </div> */}
				</div>
			</div>

			<div className="portfolio-content flex-width-70" style={{"padding-top": "0"}}>
				<div className="section-box">
					<h3 className="section-title">Documentation & Adoption</h3>
					<p>I conducted research across product verticals to understand how designs were being implemented and to identify inconsistencies and gaps. Using insights from real usage, adoption metrics, and team feedback, I created clear documentation and usage guidelines to drive consistency, reduce misuse, and align system adoption across teams.</p>
					<p>Here’s an example of my work standardizing Breakpoints & Layout across multiple products.</p>
					<br />
					<img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['documentation2.png']} alt="" />
					
				</div>
			</div>
			{/* <div className="section-box fullscreen-container flex flex-center">
				<OutcomeOverview style={{backgroundColor: "#27272B", minHeight: "0"}} className="text-center">
					<img style={{width: "80%"}} src={images['documentation2.png']} alt="documentation" />
				</OutcomeOverview>
			</div> */}
			

			<div className="portfolio-content flex-width-70" style={{"padding-top": "0"}}>
				<div className="section-box">
					<h3 className="section-title"> System Evolution & Governance</h3>
					<p>I scaled and maintained the design system through regular audits, deprecation workflows, and migration support. 
							To improve efficiency, I built custom Figma plugins for&nbsp;
							<a href="../TokenManagementPlugin" target="_blank">token spec generation and export</a>&nbsp;,
							and <a href="../fanduel" target="_blank">automated component upgrades</a>, 
							ensuring consistency and streamlining the design-to-dev handoff.
						</p>
					<img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['plugins.png']} alt="" />
					
				</div>
			</div>


			<div className="portfolio-content flex-width-70" style={{"padding-top": "0"}}>
				<div className="section-box">
						<h3>Visual Design & Asset Management</h3>
						<p>I contributed to visual consistency by helping create and review icons and shared assets across the system. I developed checklists and maintained clear library documentation to ensure accurate implementation and ease of use.</p>
					
					<img className="widthfixed" style={{"width": "100%", "borderRadius": "4px"}} src={images['icon.png']} alt="" />
					
				</div>
			</div>


			<div className="portfolio-content flex-width-70" style={{"padding-top": "20px"}}>
				<div className="section-box">
						<h3>Training session</h3>
						<p>I led training sessions to educate designers on token usage, component creation, and library management. These sessions improved system understanding, reduced misuse, and empowered teams to contribute confidently. As a result, design system adoption increased significantly, and component quality and consistency improved across products.</p>
					<div style={{width: "100%", marginTop: "2rem"}}>
						<UncontrolledExample controls={trainingControls} carouselId="training-carousel" />
					</div>
					
				</div>
			</div>

	
{/*----------------------------------- The Solution -----------------------------------*/}	

			<div className="section-box fullscreen-container flex flex-center">


		

				{/* <OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
					<div className="col-1">
					</div>
					<div className="description col-xl-4 col-md-4 col-xs-12 col-12">
						<h1>Visual Design & Asset Management</h1>
						<p>I contributed to visual consistency by helping create and review icons and shared assets across the system. I developed checklists and maintained clear library documentation to ensure accurate implementation and ease of use.</p>
					</div>
					<div className="image col-xl-6 col-md-6 col-xs-12 col-12">
						<img className="widthfixed" src={images['tokenspec.png']} alt="" />
					</div>
						
				</OutcomeOverview> */}

				

				<OutcomeOverview className="grid" style={{"min-height": "100vh"}}>
					<div className="col-2">
					</div>
					<div className="description col-xl-5 col-md-5 col-xs-12 col-12">
						<h1> Thanks for reading</h1>
						<p>If you're interested in knowing more about my work, feel free to reach out—I'd be happy to share more details.</p>
					</div>
					<div className="image col-xl-5 col-md-5 col-xs-12 col-12">
						
					</div>
						
				</OutcomeOverview>


				




			</div>





			{/*----------------------------------- The Solution -----------------------------------*/}	
			

			

			







			
			



			<ScrollToTopBtn></ScrollToTopBtn>
		</div>
		)
	
}
export default Wyndham;